<template>
  <div class="ss__mobile__submenu__wrapper" :style="submenu.style || ''">
    <SsButton2 class="btn__back" @click="$emit('back')" type="text">
      <i class="ssCommunityIcon__arrowBack"/>
    </SsButton2>
    <div
      v-for="item in submenu.children"
      :key="item.name"
      class="ss__mobile__submenu__item"
      :style="item.style">
      <div class="ss__mobile__submenu__name">
        {{ item.name }}
      </div>
      <div :class="[
        'ss__mobile__submenu__list',
        `ss__mobile__submenu__list--${item.layout}`]">
        <component
          class="comp__SsMobileMenuItem"
          v-for="child in item.children"
          :key="child.name"
          :item="child"
          :is="child.card"
          :style="child.style"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SsButton2 from '../../../SsButton2'
import SsDesktopMenuItem from '@/components/SsCustomHeader/_components/SsDesktopMenuItem/index.vue'
import SsDesktopMenuPostItem from '@/components/SsCustomHeader/_components/SsDesktopMenuPostItem/index.vue'
import SsDesktopMenuSeriesItem from '@/components/SsCustomHeader/_components/SsDesktopMenuSeriesItem/index.vue'
import SsDesktopMenuGoodItem from '@/components/SsCustomHeader/_components/SsDesktopMenuGoodItem/index.vue'
import SsDesktopMenuPrimeExplore from '@/components/SsCustomHeader/_components/SsDesktopMenuPrimeExplore/index.vue'
import SsCoCreationItemCard from '@/components/SsCoCreationItemCard/index.vue'
import SsCoCreationEntryCard from '@/components/SsCoCreationEntryCard/index.vue'

export default {
  name: 'SsMobileSubmenu',

  components: {
    SsButton2,
    SsDesktopMenuItem,
    SsDesktopMenuPostItem,
    SsDesktopMenuSeriesItem,
    SsDesktopMenuGoodItem,
    SsDesktopMenuPrimeExplore,
    SsCoCreationItemCard,
    SsCoCreationEntryCard
  },

  props: {
    submenu: {
      type: Object,
      required: true
    }
  },

  watch: {
    submenu: {
      immediate: true,
      handler () {
        setTimeout(this.addWheelMonitor, 100)
      }
    }
  },

  methods: {
    addWheelMonitor () {
      const scrollAmount = 50
      const els = this.$el.querySelectorAll('.ss__mobile__submenu__item .ss__mobile__submenu__list')
      els.forEach(el => {
        if (el.scrollWidth > el.clientWidth) {
          el.addEventListener('wheel', evt => {
            evt.preventDefault()
            const delta = event.deltaY || event.detail || event.wheelDelta
            if (delta > 0) {
              el.scrollLeft += scrollAmount
            } else {
              el.scrollLeft -= scrollAmount
            }
          })
        }
      })
    }
  },

  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
.ss__mobile__submenu__wrapper {
  .btn__back {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: var(--B8-t);
    margin: 24px 0;
    &::before {
      background: transparent;
    }
  }
  .ss__mobile__submenu__item:not(:last-child) {
    border-bottom: 1px solid var(--B3-t);
    padding-bottom: 16px;
    margin-bottom: 24px;
  }
  .ss__mobile__submenu__name {
    font-size: var(--text-SsMobileSubmenuName, 22px);
    color: var(--color-SsMobileSubmenuName, var(--B8-t));
    font-weight: var(--weight-SsMobileSubmenuName, 500);
    font-family: var(--font-SsMobileSubmenuName, inherit);
    margin-bottom: 16px;
    margin-top: 24px;
  }
  .ss__mobile__submenu__list {
    margin: var(--margin-SsMobileSubmenuChildren, 0px)
    padding: var(--padding-SsMobileSubmenuChildren, 0px)
    .comp__SsMobileMenuItem {
      box-sizing: border-box;
      --w-SsDesktopMenuItemContent: var(--w-SsDesktopSubmenuItemChild, 100%);
      --h-SsDesktopMenuItemContent: var(--h-SsDesktopSubmenuItemChild, 56px);
      --gap-SsDesktopMenuItemInner: var(--gap-SsDesktopSubmenuItemChild, 8px);
      --size-SsDesktopMenuItemIcon: var(--size-SsDesktopSubmenuItemChildIcon, 32px);
      --padding-SsDesktopMenuItemIcon: var(--padding-SsDesktopSubmenuItemChildIcon, 0px)
      --font-SsDesktopMenuItemName: var(--font-SsDesktopSubmenuItemChildName, inherit);
      --text-SsDesktopMenuItemName: var(--text-SsDesktopSubmenuItemChildName, 17px);
      --weight-SsDesktopMenuItemName: var(--weight-SsDesktopSubmenuItemChildName, 500);
      margin: var(--gap-SsMobileMenuItem, 4px) 0;
    }
  }
  .ss__mobile__submenu__list--card {
    display: flex;
    overflow: auto;
    column-gap: 24px;
    padding-bottom: 16px;
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .ss__mobile__submenu__list--normal {
    display: var(--display-SsDesktopSubmenuItemChildren, block);
    flex-direction: var(--direction-SsDesktopSubmenuItemChildren, row);
    flex-wrap: var(--wrap-SsDesktopSubmenuItemChildren, nowrap);
    column-gap: var(--gap-SsDesktopSubmenuItemChildren, 0px);
    row-gap: var(--gap-SsDesktopSubmenuItemChildren, 0px);
    overflow: auto;
  }
}
</style>
